class PaymentBlock {

    constructor(priceBox, price) {
        
        this.paymentBlockEl = $('#paymentBlock');
        this.priceBoxEl = priceBox;
        this.price = price;
    }

    fillWithInfo() {
        this.setPrice();
        this.setVersionInfo();        
        this.resetDiscountInfo();
    }

    show() {
        
        $('#giftCertInfoBlock').removeClass('margin-top-50').addClass('margin-top-3ž0');
        $('#giftCertInfoBlock hr').hide();

        $('#paymentBlock').collapse('show');
        smoothScrollToTarget('#paymentBlock', 1600);
    }


    setPrice() {
        const formattedPrice = formatCurrency(this.price, this.paymentBlockEl.data('currency'));
        this.paymentBlockEl.find('.price').text(formattedPrice);
        this.paymentBlockEl.find('.price').attr('data-price', this.price);
        this.paymentBlockEl.find('.price').css('text-decoration', 'none').css('color', '#5cad48');
    }

    setVersionInfo() {
        this.paymentBlockEl.find('.version').text(this.priceBoxEl.attr('data-versionName'));
        this.paymentBlockEl.find('.version-info').text(this.priceBoxEl.attr('data-versionInfo'));
    }

    resetDiscountInfo() {
        this.paymentBlockEl.find('.discounted-price').hide();
        $('#discount-info-link').show();
        $('#discount-info-input').val(null);
    }
}
